<div class="mt-2">
	<app-paging-search-bar [parentApi]="getParentMethod()" [centered]="false"></app-paging-search-bar>

	<table *ngIf="!loading && itemsToShow.length > 0" class="cp-std-table cp-auto-width">
		<thead>
			<tr app-column-headings [parentApi]="getParentMethod()" [columnDefs]="columnDefs" [fieldsToShow]="fieldsToShow"
				[displayOptions]="displayOptions">
			</tr>

		</thead>
		<tbody *ngIf="itemsToShow && !loading">
			<tr *ngFor="let item of itemsToShow" [ngClass]="{'text-danger': item.is_enabled === 0}">
				<td class="cp-icon-cell">
					<fa-icon *ngIf="item.is_enabled === 1" [icon]="['fas', 'power-off']" size="sm" class="text-success"
						ngbTooltip="Enabled - Available for download" placement="end"></fa-icon>
					<fa-icon *ngIf="item.is_enabled === 0" [icon]="['fas', 'ban']" size="sm" class="text-danger"
						ngbTooltip="Disabled - Not available for download" placement="end"></fa-icon>
				</td>
				<td class="cp-icon-cell">
					<fa-icon *ngIf="!!item.release_notes && item.release_notes !== ''" [icon]="['fas', 'glasses']" size="sm"
						class="text-success" ngbTooltip="Has inline release notes" placement="end">
					</fa-icon>
					<fa-icon *ngIf="!item.release_notes || item.release_notes === ''" [icon]="['fas', 'glasses']" size="sm"
						class="text-danger" ngbTooltip="Does not have inline release notes" placement="end">
					</fa-icon>
				</td>
				<td class="cp-icon-cell">
					<fa-icon *ngIf="item.release_notes_file_id !== 0" [icon]="['fas', 'book']" size="sm" class="text-success"
						ngbTooltip="Has a release notes file" placement="end"></fa-icon>
					<fa-icon *ngIf="item.release_notes_file_id === 0" [icon]="['fas', 'book']" size="sm" class="text-danger"
						ngbTooltip="Does not have a release notes file" placement="end"></fa-icon>
				</td>
				<td class="cp-icon-cell">
					<fa-icon *ngIf="item.is_private === 1" [icon]="['fas', 'lock']" size="sm" class="text-warning"
						ngbTooltip="Private - Limited Access" placement="end"></fa-icon>
					<fa-icon *ngIf="item.is_private === 0" [icon]="['fas', 'globe']" size="sm" class="text-success"
						ngbTooltip="Public - Generally Available" placement="end"></fa-icon>
				</td>

				<td class="cp-icon-cell">
					<fa-icon *ngIf="item.is_retired === 1" [icon]="['fas', 'snooze']" size="sm" class="text-info"
						ngbTooltip="Archived - no longer downloadable without direct access" placement="end">
					</fa-icon>
				</td>

				<td *ngIf="showProduct" class="cp-chopped-col-long">{{ item.prod_name }}</td>
				<td>
					<a [routerLink]="['/' + ac.urls.builds, item.id]">
						{{ item.version }}
						<span *ngIf="item.label && item.label !== ''">({{ item.label }})</span>
					</a>
				</td>
				<td class="text-center text-nowrap">
					<span [ngbTooltip]="item['__platforms']">
						<fa-icon *ngFor="let icon of item['__platform_icons']" [icon]="icon" class="me-1">
						</fa-icon>
					</span>
				</td>
				<td class="text-center">{{ item.platform_files.length }}</td>
				<td class="text-center">{{ item.org_ids.length }}</td>
				<td class="text-center">{{ item.group_ids.length }}</td>
				<td class="text-center">{{ item.package_ids.length }}</td>
				<td class="text-center text-nowrap">
					<div *ngIf="item.added_on" [ngbTooltip]="item.added_on | date: ac.shortPageDateTimeFmt">
						{{ item.added_on | timeback }}
					</div>
				</td>
				<td class="text-center text-nowrap">
					<div *ngIf="item.last_download" [ngbTooltip]="item.last_download | date: ac.shortPageDateTimeFmt">
						{{ item.last_download | timeback }}
					</div>
				</td>
			</tr>
		</tbody>
	</table>
	<app-paging-bar [parentApi]="getParentMethod()" [pageNum]="displayOptions.pageNum" [pagingOptions]="pagingOptions"
		[centered]="false"></app-paging-bar>
</div>